import React from 'react';

import DownArrow from '@material-ui/icons/KeyboardArrowDownRounded';
import UpArrow from '@material-ui/icons/KeyboardArrowUpRounded';
import Line from '@material-ui/icons/RemoveRounded';

import { SortingOptions } from '../../../../../../contrib/utils';

interface ISortIcon {
  attribute: string;
  orderBy: string;
  order: SortingOptions;
  onClick: (attribute: any) => void;
}

export const SortIcon = (props: ISortIcon) => {
  const { orderBy, attribute, order, onClick } = props;
  const Icon = orderBy === attribute ? (order === 'asc' ? DownArrow : UpArrow) : Line;

  return <Icon classes={{ root: 'player-list-icon override' }} onClick={onClick} />;
};
